export const defaultSource: Source = {
  id: "",
  name: "None",
  availableForNewProjects: true,
  databaseName: "",
  schemaIdentifier: "",
  datasetCutoffDate: "",
};

export const schemaIdentifier = {
  mayo_dug_215: "mayo_dug_215",
  mayo_dug_216: "mayo_dug_216",
};
